// tslint:disable
// @ts-nocheck
/**
 * Enter API Documentation
 * ## Interactive Documentation ##### Our API documentation allows you to test API calls straight from this website. ##### To do this, scroll down a little and click the green \"Authorize\" button (with a padlock) to the right and below. A pop-up should appear. ##### In the popup, enter your \"client_id\" and \"client_secret\" values (these will be provided to you) and press \"Authorize\". You should now be logged in (you can open up your network tab to see the API traffic going through). ##### From here, you can click any endpoint below to expand its details and click the \"Try it out\" button that appears in the expanded section. ##### Fill out the parameter fields and then click \"Execute\" to call the endpoint. The results of your query should be shown below. ## Authentication ##### Our API uses the OAuth 2.0 Client Credentials flow to authorize clients. ##### With your provided \"Client Id\" and \"Client Secret\", make the following call: ``` POST /oauth/token HTTP/1.1 Host: api.enter.health  grant_type=client_credentials &client_id=XXXXXXXXXXXX &client_secret=YYYYYYYYYYY ``` ##### Here\'s an example CURL request: ``` curl \'https://api.enter.health/oauth/token\' -H \'accept: application/json\' --data \'grant_type=client_credentials&client_id=XXXXXXXXXXXX&client_secret=YYYYYYYYYYY\' ``` ##### The response should look something like this ``` {   \"access_token\" : \"AAAAAAAAAAAAAAAAAAA\",   \"refresh_token\" : \"BBBBBBBBBBBBBBBBBBB\" }  ``` ##### With the access token provided, you can make an authenticated call to any of the endpoints below by including the header \"Authorization: Bearer AAAAAAAAAAAAAAAAAAA\" with your API request. ##### Here\'s an example of a basic curl request to the \"/me\" endpoint ``` curl \'https://api.enter.health/me\' -H \'accept: application/json\' -H \'authorization: Bearer AAAAAAAAAAAAAAAAAAA\' ``` ##### Note that access tokens are not long-living tokens. The lifetime of them differs from client to client, but they may last as short as 15 minutes (if you would like an increase in time, please reach out to us). ### Comparators ##### Filter parameters need to be formatted with a comparator and value in the format of \"COMPARATOR:VALUE\". The following is a list of possible values:  ##### GTE - Greater than or equal ##### GT - Greater than ##### LT - Less Than ##### LTE - Less than or equal ##### EQ - Equal ##### NQ - Not Equal ##### LK - Like ##### NLK - Not Like ##### EMPTY - Is null ##### NEMPTY - Is not null ## Subject to Change ##### Note that this API is in active development and may be subject to changes at any time. ##### This document is a living document with current specifications. If your integration does not seem to work properly, please refer back to this page to look for updates. ##### If you are still having issues, please reach out to support. 
 *
 * The version of the OpenAPI document: 2
 * Contact: support@enter.health
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists } from '../runtime';
import {
    Revision,
    RevisionFromJSON,
    RevisionToJSON,
    SupportDocumentSizeType,
    SupportDocumentSizeTypeFromJSON,
    SupportDocumentSizeTypeToJSON,
    SupportDocumentType,
    SupportDocumentTypeFromJSON,
    SupportDocumentTypeToJSON,
    Tags,
    TagsFromJSON,
    TagsToJSON,
} from './';

/**
 * 
 * @export
 * @interface SupportDocument
 */
export interface SupportDocument extends Tags {
    /**
     * The id of the Document
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof SupportDocument
     */
    id?: string;
    /**
     * The filename with extension
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof SupportDocument
     */
    filename?: string;
    /**
     * User generated description
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof SupportDocument
     */
    description?: string;
    /**
     * Width of Image or PDF (if a PDF has mismatched page sizes, this will be 0)
     * OpenAPI data type: {integer}
     * @type {number}
     * @memberof SupportDocument
     */
    width?: number;
    /**
     * Height of Image or PDF (if a PDF has mismatched page sizes, this will be 0)
     * OpenAPI data type: {integer}
     * @type {number}
     * @memberof SupportDocument
     */
    height?: number;
    /**
     * File size in bytes
     * OpenAPI data type: {integer}
     * @type {number}
     * @memberof SupportDocument
     */
    filesize?: number;
    /**
     * Notes added during document generation
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof SupportDocument
     */
    notes?: string;
    /**
     * The identified mime type of the document
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof SupportDocument
     */
    mimetype?: string;
    /**
     * 
     * OpenAPI data type: {SupportDocumentSizeType}
     * @type {SupportDocumentSizeType}
     * @memberof SupportDocument
     */
    size?: SupportDocumentSizeType;
    /**
     * A base-64 encoded thumbnail url. Null if not available.
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof SupportDocument
     */
    thumbnail?: string;
    /**
     * Claims associated with a document
     * OpenAPI data type: {array}
     * @type {Array<string>}
     * @memberof SupportDocument
     */
    claimIds?: Array<string>;
    /**
     * Documents that were used as sources for this document
     * OpenAPI data type: {array}
     * @type {Array<string>}
     * @memberof SupportDocument
     */
    sourceDocumentIds?: Array<string>;
    /**
     * This field is DEPRECATED. Latest claim id associated with the document
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof SupportDocument
     */
    claimId?: string;
    /**
     * The document is active.
     * OpenAPI data type: {boolean}
     * @type {boolean}
     * @memberof SupportDocument
     */
    active?: boolean;
    /**
     * 
     * OpenAPI data type: {SupportDocumentType}
     * @type {SupportDocumentType}
     * @memberof SupportDocument
     */
    documentType?: SupportDocumentType;
    /**
     * 
     * OpenAPI data type: {string}
     * @type {Date}
     * @memberof SupportDocument
     */
    created?: string;
    /**
     * The revision group
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof SupportDocument
     */
    groupId?: string;
    /**
     * Revisions within the resource group
     * OpenAPI data type: {array}
     * @type {Array<Revision>}
     * @memberof SupportDocument
     */
    revisions?: Array<Revision>;
}

export function SupportDocumentFromJSON(json: any): SupportDocument {
    return {
                'id': !exists(json, 'id') ? undefined : json['id'],
                'filename': !exists(json, 'filename') ? undefined : json['filename'],
                'description': !exists(json, 'description') ? undefined : json['description'],
                'width': !exists(json, 'width') ? undefined : json['width'],
                'height': !exists(json, 'height') ? undefined : json['height'],
                'filesize': !exists(json, 'filesize') ? undefined : json['filesize'],
                'notes': !exists(json, 'notes') ? undefined : json['notes'],
                'mimetype': !exists(json, 'mimetype') ? undefined : json['mimetype'],
                'size': !exists(json, 'size') ? undefined : SupportDocumentSizeTypeFromJSON(json['size']),
                'thumbnail': !exists(json, 'thumbnail') ? undefined : json['thumbnail'],
                'claimIds': !exists(json, 'claimIds') ? undefined : json['claimIds'],
                'sourceDocumentIds': !exists(json, 'sourceDocumentIds') ? undefined : json['sourceDocumentIds'],
                'claimId': !exists(json, 'claimId') ? undefined : json['claimId'],
                'active': !exists(json, 'active') ? undefined : json['active'],
                'documentType': !exists(json, 'documentType') ? undefined : SupportDocumentTypeFromJSON(json['documentType']),
                'created': !exists(json, 'created') ? undefined : json['created'],
                'groupId': !exists(json, 'groupId') ? undefined : json['groupId'],
                'revisions': !exists(json, 'revisions') ? undefined : (json['revisions'] as Array<any>).map(RevisionFromJSON),
        ...TagsFromJSON(json)
    };

}

export function SupportDocumentToForm(value?: SupportDocument): any {
    let jsonVal = SupportDocumentToJSON(value);
    let retVal = '';
    if(jsonVal !== undefined && jsonVal != null) {
        Object.keys(jsonVal).forEach((v, i) => {
            if(i > 0) retVal+= "&";
            retVal+= encodeURIComponent(v) + "=" + encodeURIComponent(jsonVal[v]);
        });
    }
    return retVal;
}

function cleanupBlankValuesForBackend(val?:any): any {
    if(val instanceof Array) {
        return (val as Array<any>).filter((val) => { return val !== undefined && val !== null && val !== ''});
    } else {
        return (val === '') ? null : val;
    }
}

export function SupportDocumentToJSON(value?: SupportDocument): any {
    value = cleanupBlankValuesForBackend(value);
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
            'id': cleanupBlankValuesForBackend(value.id),
            'filename': cleanupBlankValuesForBackend(value.filename),
            'description': cleanupBlankValuesForBackend(value.description),
            'width': cleanupBlankValuesForBackend(value.width),
            'height': cleanupBlankValuesForBackend(value.height),
            'filesize': cleanupBlankValuesForBackend(value.filesize),
            'notes': cleanupBlankValuesForBackend(value.notes),
            'mimetype': cleanupBlankValuesForBackend(value.mimetype),
            'size': SupportDocumentSizeTypeToJSON(value.size),
            'thumbnail': cleanupBlankValuesForBackend(value.thumbnail),
            'claimIds': cleanupBlankValuesForBackend(value.claimIds),
            'sourceDocumentIds': cleanupBlankValuesForBackend(value.sourceDocumentIds),
            'claimId': cleanupBlankValuesForBackend(value.claimId),
            'active': cleanupBlankValuesForBackend(value.active),
            'documentType': SupportDocumentTypeToJSON(value.documentType),
            'created': cleanupBlankValuesForBackend(value.created),
            'groupId': cleanupBlankValuesForBackend(value.groupId),
            'revisions': (value.revisions === undefined || value.revisions === null) ? undefined  : (value.revisions as Array<any>).map(RevisionToJSON),
            ...TagsToJSON(value)
    };
}


